import type { Ctx } from "../../types";
import { Query } from "gg-wf-scripts";
import { REVIEW_STATUS_OPTIONS } from "../_status_labels";
import { sortByLabel } from "./_helpers";

export const select_review_statuses: Query<Ctx> = async (_ctx, _params) =>
  sortByLabel(REVIEW_STATUS_OPTIONS);
